import { mapState } from 'vuex'

export default {
  name: 'PermissionListExpand',
  props: {
    data: Object
  },
  computed: {
    ...mapState(['config']),
    tableHeaders () {
      return [
        { key: 'user.fullname', label: this.$t('Apstiprinātājs') },
        { key: 'user_mode', label: this.$t('Apstiprinātāja loma'), format: 'formatFunc', funcs: [this.getUserModeName] },
        { key: 'status', label: this.$t('Statuss'), format: 'formatFunc', funcs: [this.getStatusName] }
      ]
    }
  },
  methods: {
    getStatusName (statusId) {
      const status = this.$store.getters.getDataFromConfigWithFilter('decision_statuses', 'value', statusId);
      if (status) {
        return this.$t('decisions.statuses.' + status.name);
      } else {
        return '-';
      }
    },
    getUserModeName (userMode) {
      let text = null;
      if (userMode === 1) { // @TODO from configoptions
        text = 'Sistēmas menedžeris';
      } else if (userMode === 2) {
        text = 'Tiešais vadītājs';
      }
      return text;
    }
  }
}
